import config from '@/config';
import axios, {AxiosResponse} from 'axios';

interface SessionResponse {
    session: string;
}

export default class Session {
    public static async login(username: string, password: string): Promise<string> {
        const response: AxiosResponse<SessionResponse> = await axios.post(
            config.API_ROOT + '/session/',
            {username, password}
        );
        
        return response.data.session;
    }
    
    public static async logout(sessionToken: string): Promise<void> {
        await axios({
            method: 'DELETE',
            url: config.API_ROOT + '/session/',
            headers: {
                'X-Session': sessionToken,
            },
        });
    }
}
